<template>
	<div id="asl-consent-page" class="page">
		<template v-if="globalState.menuOpen">
			<div id="blockScreen" class="block-screen" @click="closeMenu"></div>
		</template>
		<Menu></Menu>
		<RemoteHeader :heading="$t('signLanguagePageHeadingLabel')"></RemoteHeader>
		<ASLRemoteHeaderButtonContainer>
			<ASLCloseButton />
		</ASLRemoteHeaderButtonContainer>
		<ASLGettingStarted />
</div>
</template>

<script>
import RemoteHeader from "@/components/RemoteHeader.vue";
import Menu from '@/components/Menu.vue';
import ASLGettingStarted from '@/components/ASLGettingStarted.vue';
import ASLRemoteHeaderButtonContainer from "@/components/ASLRemoteHeaderButtonContainer.vue";
import ASLCloseButton from "@/components/ASLCloseButton.vue";

export default {
	data() {
		return {
			globalState: ar.state
		}
	},
	name: "ASLGettingStartedPage",
	components: {
		RemoteHeader,
		Menu,
		ASLGettingStarted,
		ASLRemoteHeaderButtonContainer,
		ASLCloseButton
	},
	methods: {
		closeMenu: function () {
			if (this.globalState.menuOpen) {
				this.globalState.menuOpen = false;
			}
		}
	},
	mounted: function() {
		window.focusPageHeading("h2");
		window.setPageTitle('signLanguagePageHeadingLabel');
	}
};
</script>

<style lang="scss" scoped>

</style>
